// extracted by mini-css-extract-plugin
module.exports = {"logInButton":"landing-header_logInButton__3oaca","registerButton":"landing-header_registerButton__nYCKf"};